<template>
  <div>
    <HDatePicker
      v-model="date"
      v-show="true || !date"
      :label="dateLabel"
      :rules="rules"
      dateTimeMode="true"
      @input="setDate"
      ref="datePicker"
    />

    <HTimePicker
      v-if="isByHours"
      v-model="time"
      @input="setHour"
      :rules="rules"
      :label="timeLabel"
      :isToday="isToday"
      :startDateDelay="startDateDelay"
      ref="timePicker"
      dateTimeMode
    />

    <HPeriodPicker
      v-else
      v-model="time"
      @input="setHour"
      @setSlotSize="setSlotSize"
      :label="periodLabel"
      :selectedDate="date"
      :isToday="isToday"
      :requiresEndTime="requiresEndTime"
      ref="periodPicker"
    />

    <VMessages v-if="validationState" :value="errorBucket" color="error" />
  </div>
</template>

<script>
// third party
import moment from 'moment'
import { mapMutations } from 'vuex'

// components
import VInput from 'vuetify/lib/components/VInput/VInput.js'
import HTimePicker from './HTimePicker'
import HDatePicker from './HDatePicker'
import HPeriodPicker from './HPeriodPicker'

// constants
const DATE_ONLY_FORMAT = 'YYYY-MM-DD'
const TIME_ONLY_FORMAT = 'HH:mm'

export default {
  name: 'HDateTimePicker',
  extends: VInput,
  components: {
    HDatePicker,
    HTimePicker,
    HPeriodPicker,
  },

  props: ['value', 'dateLabel', 'timeLabel', 'periodLabel', 'isByHours', 'requiresEndTime'],

  data() {
    return {
      date: null,
      time: null,
      isToday: false,
      startDateDelay: 0,
      slotSize: 0,
    }
  },

  watch: {
    value: function() {
      this.updateDateAndTime()
    },
  },

  methods: {
    ...mapMutations(['setAppointmentCreationConfirmToClose']),

    initDateTime() {
      this.updateDateAndTime()
    },

    updateDateAndTime() {
      if (this.value) {
        let dateTime = moment(this.value)
        this.date = dateTime.format(DATE_ONLY_FORMAT)
        this.time = dateTime.format(TIME_ONLY_FORMAT)
      } else {
        this.date = null
        this.time = null
      }
    },

    getJointDateAndTime() {
      let dateTime = moment(this.date)
      const hourAndMinute = this.time.split(':')

      dateTime.set({
        hour: hourAndMinute[0],
        minute: hourAndMinute[1],
        second: 0,
        millisecond: 0,
      })

      return dateTime.format()
    },

    setDate() {
      if (this.date) {
        this.$refs.timePicker && (this.$refs.timePicker.disableAllHours = false)
        this.$refs.timePicker && this.$refs.timePicker.resetValue()
        this.$refs.timePicker && this.$refs.timePicker.resetCustomSelect()
        this.isToday = this.checkIsToday()
        this.$emit('input', moment(this.date).format('YYYY-MM-DD'))
      }

      if (this.date || this.time) {
        this.setAppointmentCreationConfirmToClose(true)
      }
    },

    setHour() {
      if (this.date && this.time) {
        this.$emit('input', this.getJointDateAndTime())
      }
    },

    setSlotSize(slotSize, periodKey) {
      this.slotSize = slotSize
      this.$emit('setSlotSize', slotSize, periodKey)
    },

    checkIsToday() {
      const today = moment().format(DATE_ONLY_FORMAT)
      const selectedDate = moment(this.date).format(DATE_ONLY_FORMAT)

      return today === selectedDate
    },

    resetValue() {
      this.date = null
      this.time = null
      this.slotSize = 0

      this.$refs.datePicker?.resetValue()
      this.$refs.timePicker?.resetValue()
      this.$refs.periodPicker?.resetValue()
    },
  },
}
</script>
